<template>
    <q-list class="q-mb-md">
        <q-collapsible icon="fas fa-filter" v-model="open" @click="toggle" :label="getNameFilter">
            <div class="row gutter-sm" v-if="options">

                <div class="col-xs-12 col-sm-12" v-if="options.branch_types && options.branch_types.length">
                    <q-select filter autofocus-filter v-model="filters.branch_type" chips :options="options.branch_types" multiple :float-label="$t('branch_type')" clearable />
                </div>

                <div class="col-xs-12 col-sm-12">
                    <q-chips-input v-model="filters.companies_label" :float-label="$t('headquarter')" @remove="removeHeadquarter" filter autofocus-filter>
                        <q-autocomplete
                            @search="fetchHeadquarters"
                            @selected="selectHeadquarter"
                            :debounce="500"
                            :min-characters="1"
                            :max-results="100"
                        />
                    </q-chips-input>
                </div>

                <div class="col-xs-12 col-sm-12">
                    <q-chips-input v-model="filters.managers_list" :float-label="$t('managers')" @remove="removeManager" >
                        <q-autocomplete
                            @search="searchManager"
                            @selected="selectManager"
                            :debounce="500"
                            :min-characters="3"
                            :value-field="v => `${ v.full_name } - ${ v.email }`"
                        />
                    </q-chips-input>
                </div>

                <div class="col-xs-12 col-sm-12" v-if="options.statuses">
                    <q-select chips multiple v-model="filters.status" :options="options.statuses" :float-label="$t('status')" clearable />
                </div>

            </div>
            <div class="row gutter-sm justify-end q-mt-sm">
                <div class="col-xs-12 col-sm-3">
                    <q-btn color="negative" class="full-width" :label="$t('clear_filters')" icon="fas fa-eraser" @click="clearFilter()"/>
                </div>
                <div class="col-xs-12 col-sm-3">
                    <q-btn color="secondary" class="full-width" :label="$t('apply_filter_plural')" icon="fas fa-filter" @click="requestFiltered()"/>
                </div>
            </div>
        </q-collapsible>
    </q-list>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    props: ['options'],
    data() {
        return {
            open: false,
            filters: {
                status: [],
                branch_type: [],
                companies: [],
                companies_label: [],
                company: [],
                managers_full_data: [],
                managers: [],
                managers_list: []
            }
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            branches_filters: 'admin_filters/branches_filters'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getNameFilter() {
            if (Object.entries(this.filters).find((a) => a[1] && a[1].length > 0)) {
                return `${this.$t('filter')} <i class="fas fa-exclamation-circle"></i>`
            } else return this.$t('filter')
        }
    },

    methods: {
        requestFiltered() {
            this.$emit('requestFiltered', {
                status: this.filters.status,
                branch_type: this.filters.branch_type,
                company: this.filters.company,
                manager: this.filters.managers
            })
            this.saveBranchesFilters()
            setTimeout(() => { this.toggle() }, 500)
        },

        clearFilter() {
            this.filters.status = []
            this.filters.branch_type = []
            this.filters.companies = []
            this.filters.companies_label = []
            this.filters.company = []
            this.filters.managers_full_data = [],
            this.filters.managers = [],
            this.filters.managers_list = []
            this.$emit('clearAndRequest')
            this.clearStoredFilters()
            setTimeout(() => { this.toggle() }, 500)
        },

        toggle() {
            this.open = !this.open
        },

        saveBranchesFilters() {
            this.$store.dispatch('admin_filters/SET_BRANCHES_FILTERS', { branches_filters: this.filters })
        },

        loadBranchesFilters() {
            this.filters = this.branches_filters
            setTimeout(() => {
                this.requestFiltered()
            }, 1000)
        },

        clearStoredFilters() {
            this.$store.dispatch('admin_filters/SET_BRANCHES_FILTERS', { branches_filters: {} })
        },

        fetchHeadquarters(terms, done) {
            this.$axios.get(`/admin_companies/companies/get_companies/?search=${terms}`, this.getHeader)
            .then(response => {
                let headquarters = []

                response.data.forEach(element => {
                    headquarters.push({
                        value: element.id,
                        label: `${element.name} / ${this.$t(element.company_type_label)} ${element.document && element.register ? `${element.document} - ${element.register}` : element.document ? element.document : element.register ? element.register : ''}`,
                        address: element.address,
                        client: element.client,
                        company_type: element.company_type,
                        company_type_label: element.company_type_label,
                        created_date: element.created_date,
                        document: element.document,
                        fantasy: element.fantasy,
                        id: element.id,
                        name: element.name,
                        qty_branches: element.qty_branches,
                        status: element.status,
                        updated_date: element.updated_date
                    })
                })

                done(headquarters)
            })
            .catch(e => {
                done([])
                console.log(e)
            })
        },

        selectHeadquarter(item) {
            this.filters.company.push(item.id)
            let obj = this.filters.companies.find((obj) => { return obj.id === item.id })
            if (!obj) {
                this.filters.companies.push(item)
            }

            this.filters.companies_label = []
            this.filters.companies.forEach(element => {
                this.filters.companies_label.push(element.name)
            })

        },

        removeHeadquarter({index, value}) {
            this.filters.companies_label.splice(index, 1)
            this.filters.company.splice(index, 1)
        },

        searchManager(terms, done) {
            this.$axios.get(`/accounts/get_users/?search=${terms}`, this.getHeader)
            .then(response => {
                let users = []

                response.data.forEach(element => {
                    users.push({
                        value: element.id,
                        label: `${element.full_name} - ${element.email}`,
                        full_name: element.full_name,
                        email: element.email,
                        id: element.id
                    })
                })

                done(users)
            })
            .catch(e => {
                done([])
                console.log(e)
            })
        },

        selectManager(item, keyboard) {
            if (!keyboard) {
                this.filters.managers_full_data.push(item)
                this.filters.managers.push(item.id)
            }
        },

        removeManager({index, value}) {
            this.filters.managers.splice(index, 1)
            this.filters.managers_full_data.splice(index, 1)
        },
    },

    mounted () {
        if (this.branches_filters && this.branches_filters.status) {
            this.loadBranchesFilters()
        }
    }
}
</script>

<style>

</style>
